/* istanbul ignore file */
import { DropdownMenu } from 'framework/ui/menu';
import React from 'react';
import IconButton from '@mui/material/IconButton';
import PurchaseOrderDeliveredInvoicesToggler from 'domain/finance/purchaseOrder/shared/Settings/PurchaseOrderDeliveredInvoicesToggler';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';

const PurchaseOrderSettings = () => {
  return (
    <DropdownMenu
      popupId="purchase-order-settings"
      iconButton={
        <IconButton className="dropdown-toggle">
          <SettingsIcon />
        </IconButton>
      }
    >
      <PurchaseOrderDeliveredInvoicesToggler />
    </DropdownMenu>
  );
};

export default PurchaseOrderSettings;
